/* eslint-disable no-undef, no-redeclare */
// The below should go into Supernova
window.shadeBlend = function (p, c0, c1) {
  var n = p < 0 ? p * -1 : p,
    u = Math.round,
    w = parseInt

  if (c0.length > 7) {
    var f = c0.split(','),
      t = (c1 ? c1 : p < 0 ? 'rgb(0,0,0)' : 'rgb(255,255,255)').split(','),
      R = w(f[0].slice(4)),
      G = w(f[1]),
      B = w(f[2])

    return (
      'rgb(' +
      (u((w(t[0].slice(4)) - R) * n) + R) +
      ',' +
      (u((w(t[1]) - G) * n) + G) +
      ',' +
      (u((w(t[2]) - B) * n) + B) +
      ')'
    )
  } else {
    var f = w(c0.slice(1), 16),
      t = w((c1 ? c1 : p < 0 ? '#000000' : '#FFFFFF').slice(1), 16),
      R1 = f >> 16,
      G1 = (f >> 8) & 0x00ff,
      B1 = f & 0x0000ff

    return (
      '#' +
      (
        0x1000000 +
        (u(((t >> 16) - R1) * n) + R1) * 0x10000 +
        (u((((t >> 8) & 0x00ff) - G1) * n) + G1) * 0x100 +
        (u(((t & 0x0000ff) - B1) * n) + B1)
      )
        .toString(16)
        .slice(1)
    )
  }
}

window.hexToR = function (h) {
  return parseInt(cutHex(h).substring(0, 2), 16)
}
window.hexToG = function (h) {
  return parseInt(cutHex(h).substring(2, 4), 16)
}
window.hexToB = function (h) {
  return parseInt(cutHex(h).substring(4, 6), 16)
}
window.cutHex = function (h) {
  return h.charAt(0) == '#' ? h.substring(1, 7) : h
}

// Takes RGB color and returns recommended
// text color
// http://stackoverflow.com/questions/11867545/change-text-color-based-on-brightness-of-the-covered-background-area
window.determineTextColor = function (color) {
  var R,
    G,
    B,
    o = null

  var calculate = function (R, G, B) {
    return Math.round(
      (parseInt(R) * 299 + parseInt(G) * 587 + parseInt(B) * 114) / 1000
    )
  }

  if (typeof color === 'object') {
    R = color.R
    G = color.G
    B = color.B
  } else if (typeof color === 'string') {
    // Are we already in RBG format?
    if (color.indexOf('rgb') == 0) {
      var matchColors = /^rgb\((\d+),(\d+),(\d+)\)$/
      var matches = matchColors.exec(color)
      if (matches) {
        R = matches[1]
        G = matches[2]
        B = matches[3]
      } else {
        // Throw an error here?
      }
    } else {
      // Assume that it's a hex but we should also handle "rgb() and rgba()"
      R = hexToR(color)
      G = hexToG(color)
      B = hexToB(color)
    }
  } else {
    // Throw an error here
  }

  // http://www.w3.org/TR/AERT#color-contrast
  o = calculate(R, G, B)

  if (o > 125) {
    return 'dark'
  } else {
    return 'light'
  }
}
